var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBGgraphic1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 133,
    viewBox: "0 0 135 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ornament 8",
    d: "M91.7838 82.2116C67.8961 82.2116 48.5312 62.8467 48.5312 38.959",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 33.9236
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ornament 9",
    d: "M87.9673 128.009C42.0654 128.009 4.85449 90.7984 4.85449 44.8965",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 8.4809
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ornament 10",
    d: "M82.031 113.163C117.16 113.163 145.638 84.685 145.638 49.5559C145.638 14.4269 117.16 -14.0508 82.031 -14.0508C46.9019 -14.0508 18.4242 14.4269 18.4242 49.556",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 1.69618,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBGgraphic1);
export default __webpack_public_path__ + "static/media/BGgraphic1.a8deeb4160cc66333f2207851b2d5d4b.svg";
export { ForwardRef as ReactComponent };